var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 386.08 401.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #000;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "386.08 241.49 226.16 401.4 226.16 280.69 386.07 120.77 386.08 241.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "140.81 365.99 0 365.99 0 280.63 226.16 280.63 140.81 365.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "245.27 35.41 386.08 35.41 386.08 120.77 159.93 120.77 245.27 35.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 159.92 159.92 0 159.93 120.71 0 280.63 0 159.92"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnly);
export default __webpack_public_path__ + "static/media/only.f9936e6b620e8f564480deab87bfe12b.svg";
export { ForwardRef as ReactComponent };